export type Node<T> = T & { items?: Array<Node<T>> };

export function toTree<T extends { depth: number }>(
    array: Array<Exclude<T, { items: unknown }>>,
): { items: Array<Node<T>> } {
    const rootItems: Array<Node<T>> = [];
    const stack: Array<Node<T>> = [];

    for (const element of array) {
        const node: Node<T> = { ...element };

        while (stack.length > element.depth) stack.pop();

        if (stack.length === 0) {
            rootItems.push(node);
        } else {
            const parent = stack[stack.length - 1];
            if (!parent.items) parent.items = [];
            parent.items.push(node);
        }

        stack.push(node);
    }

    return { items: rootItems };
}

export function toArray<T>(
    tree: { items?: Array<Node<Exclude<T, { depth: unknown }>>> },
    depth = 0,
): Array<T & { depth: number }> {
    const collapsed: Array<T & { depth: number }> = [];
    tree.items?.forEach((node) => {
        collapsed.push({
            ...node,
            depth,
        });
        collapsed.push(...toArray(node, depth + 1));
    });
    return collapsed;
}
